import type { InferedAnnotation, InferedAnnotationAction } from './types';
import { InferedAnnotationActionEnum } from './types';

export function inferedAnnotationsReducer(
  state: InferedAnnotation,
  action: InferedAnnotationAction
): InferedAnnotation {
  switch (action.type) {
    case InferedAnnotationActionEnum.setInferedAnnotation:
      return action.payload;
    default:
      return state;
  }
}
